import panelImageMobile from '../../../../assets/svg/panelImageMobile.svg';
import panelImage from '../../../../assets/svg/panelImage.svg';
import Panel from '../../../../components/Panel';
import { useNavigate } from 'react-router-dom';

const ConfirmationStep = () => {
  const navigate = useNavigate();
  const title = 'Sua senha foi alterada';
  const description = 'Para continuar seu cadastro, faça seu login.';
  return (
    <Panel
      buttonId="mp__btn-confirmation_login"
      buttonText="Fazer login"
      onClick={() => navigate('/login')}
      image={panelImage}
      imageMobile={panelImageMobile}
      panelType="confirmation"
      title={`${title} com sucesso`}
      description={description}
    />
  );
};

export default ConfirmationStep;
